/*
==============================
Filter -> Filtro productos v1
==============================
*/

// force the plugin that aligns to do it's job
function pokeAlignerv1() {
    $(window).trigger('resize');
}

var _Filterv1 = function($sec) {
    var $filters = $sec.find('.filters'),
        $results = $sec.find('.filter-result-v1'),
        fTop = 85,
        fOldTop = 0,
        timer_resize;

    this.onReady = function() {
        if (window.innerWidth > media.desktop && !isMobile.any()) {
            fTop = $filters.offset().top - $sec.offset().top;
            fixedDesktopFiltersv1();
            checkShrinkFiltersv1();
        }
        else if (window.innerWidth <= media.mobile) {
            $filters.css('height', $filters.find('.filters-top').outerHeight() + 4);
            $filters.find('label').on('click touchend', function(e) { e.stopPropagation(); });
            $filters.find('.filters-top, .apply-filters').on('click', fixedMobileFiltersv1);
        }

        $filters.find('.checkbox').on('change', checkboxClickedv1);

        $(window).on('scroll', function() {
            if (window.innerWidth > media.desktop && !isMobile.any()) {
                fixedDesktopFiltersv1();
            }
        }).on('resize', function() {
            if (window.innerWidth > media.mobile && window.innerWidth <= media.tablet) {
                $filters.attr('style', '');
            }
            else if (window.innerWidth > media.desktop && !isMobile.any()) {
                fixedDesktopFiltersv1();
            }
            $filters.css('opacity', 1);
        });
        $('.total-results').text($sec.find('.filter-result-v1').length);

        var cur_results = $sec.find('.filter-result-v1:visible').length;

        if (cur_results > 0) {
            $sec.find('.filter-results-v1 p.title.title-xs').show();
            $sec.find('.filter-results-v1 p.title.title-xs.txt-rojo').hide();
            $('.current-results').text(cur_results);
        }
        else {
            $sec.find('.filter-results-v1 p.title.title-xs').hide();
            $sec.find('.filter-results-v1 p.title.title-xs.txt-rojo').show();
        }
        $filters.css('opacity', 1);
    };

    function checkboxClickedv1() {
        var $fMenus = $filters.find('.filter-menu-v1'),
            filters = [];

        $fMenus.each(function() {
            var dfilters = $(this).find('.checkbox:checked'),
                fIndex = filters.length;

            if (dfilters.length > 0) {
                dfilters.prop('disabled', true);
                filters[fIndex] = filters[fIndex] || [];
                dfilters.each(function() {
                    filters[fIndex].push($(this).data('filter'));
                });
            }
        });

        $(this).parent().toggleClass('on');

         if (window.innerWidth <= media.mobile || window.innerWidth > media.desktop) {
            $('html, body').animate({
                scrollTop: $sec.offset().top
            }, 300);
        }

        setTimeout(function() {
            $results.fadeOut(400).promise().done(function() {
                if (filters.length > 0)
                    filterResultsv1(filters);
                else
                    $results.fadeIn().promise().done(pokeAlignerv1);

                var cur_results = $sec.find('.filter-result-v1:visible').length;

                if (cur_results > 0) {
                    $sec.find('.filter-results-v1 p.title.title-xs').show();
                    $sec.find('.filter-results-v1 p.title.title-xs.txt-rojo').hide();
                    $('.current-results').text(cur_results);
                }
                else {
                    $sec.find('.filter-results-v1 p.title.title-xs').hide();
                    $sec.find('.filter-results-v1 p.title.title-xs.txt-rojo').show();
                }
                $fMenus.find('.checkbox').prop('disabled', false);
            });

            // console.log('foo');
        }, 300);
    }

    function filterResultsv1(filters) {
        var filtered = [];

        $results.each(function() {
            var toFiltered = false,
                thisFilters = $(this).data('filters');

            if (thisFilters && thisFilters.length > 0) {
                for (var j = 0; j < filters.length; j++) {
                    for (var i = 0; i < thisFilters.length; i++) {
                        if (filters[j].indexOf(thisFilters[i]) > -1) {
                            toFiltered = true;
                            break;
                        }
                        else {
                            toFiltered = false;
                        }
                    }
                    if (!toFiltered) break;
                }
            }

            if (toFiltered) {
                filtered.push($(this));
            }
        });

        for (var i = 0; i < filtered.length; i++) {
            filtered[i].fadeIn().promise().done(pokeAlignerv1);
        }
    }

    function fixedDesktopFiltersv1() {
        var fwidth = $filters.outerWidth(),
            sbottomPos = ($sec.offset().top + $sec.outerHeight() - fTop) - $(window).height(),
            isOverSec = $(document).scrollTop() <= $sec.offset().top,
            isBelowSec = isFilterHigherThanSecv1();

        if (isBelowSec) {
            if ($filters.hasClass('fixed')) {
                var rTop = $sec.height() - $filters.height() - fTop;
                // console.log(rTop);
                $filters.css({
                    'top': rTop,
                    'left': 0,
                    'position':'relative'
                    // 'top': (isOverSec) ? fTop + ($sec.offset().top - $(document).scrollTop()) : fTop - $(document).scrollTop()
                });
                $sec.find('.filter-results-v1').css('margin-left', 0);

                $filters.removeClass('fixed');

                setTimeout(function() {
                    if (!$filters.hasClass('fixed')) {
                        // $filters.css({
                        //     position: 'static'
                        // });
                        //
                    }
                }, 800);
            }
        }
        else if (isOverSec) {
            if ($filters.hasClass('fixed')) {
                $filters.css({
                    position: 'static',
                    top: fTop
                });
                $sec.find('.filter-results-v1').css('margin-left', 0);
                $filters.removeClass('fixed');
            }
        }
        else if ($sec.offset().top <= $(document).scrollTop()) {
            if (!$filters.hasClass('fixed')) {
                $filters.css({
                    'top': (isOverSec) ? fTop + ($sec.offset().top - $(document).scrollTop()) : fTop - $(document).scrollTop()
                });
                $filters.css({
                    width: fwidth,
                    left: $filters.offset().left,
                    position: 'fixed',
                    top: fTop
                });
                $sec.find('.filter-results-v1').css('margin-left', fwidth);
                $filters.addClass('fixed');
            }
        }
    }

    function fixedMobileFiltersv1(e) {
        e.preventDefault();

        if (!$filters.hasClass('opened')) {
            $filters.css("height", $filters.find('.filters-top').outerHeight());
            $filters.css({
                height: $(window).height(),
                bottom: '0'
            });
            setTimeout(function() {
                $filters.addClass('opened').css({'overflow-y': 'scroll', 'overflow-x': 'hidden'});
                $filters.find('.filters-top .title-xs').slideDown();
                $('body').css('overflow-y', 'hidden');
                setTimeout(function() {
                    $filters.css('padding-top', $filters.find('.filters-top').outerHeight() + 4).find('.filter-menu-v1').fadeIn().promise().done(pokeAlignerv1);
                    onGlobalResize();
                }, 400);
            }, 800);
        }
        else {
            $filters.css({
                'overflow-y': 'visible',
                'overflow-x': 'visible'
            }).find('.filter-menu-v1').fadeOut(400);
            $filters.find('.filters-top .title-xs').slideUp(400);
            $('body').css('overflow-y', 'visible');

            setTimeout(function() {
                $filters.css({
                    bottom: '-3px',
                    height: $filters.find('.filters-top').outerHeight() + 4,
                    'padding-top': 0
                }).removeClass('opened');
            }, 400);
        }
    }

    function checkShrinkFiltersv1() {
        var isOverSec = $(document).scrollTop() <= $sec.offset().top,
            $flastMenu = $filters.find('.filter-menu-v1:not(.collapsed)').last();

        if ($filters.find('.filter-menu-v1:not(.collapsed)').length > 3 && isFilterHigherThanWindowv1()) {
            $flastMenu.addClass('collapsed');

            if (!$filters.find('.filters-layer').hasClass('big') && $filters.find('.filters-layer').height() + $flastMenu.height() < $filters.height()) {
                $filters.find('.filters-layer').css('width', $filters.width()).append($flastMenu);
            }
            else {
                $filters.addClass('big').find('.filters-layer').addClass('big').css('width', $filters.width()*2).append($flastMenu);
            }
            checkShrinkFiltersv1();
        }
    }

    function isFilterHigherThanSecv1() {
        return ($(document).scrollTop() - ($(window).height() - $filters.height() - fTop)) >= ($sec.offset().top + $sec.outerHeight() - fTop) - $(window).height();
    }

    function isFilterHigherThanWindowv1() {
        return ($sec.find('.filters').height() + (fTop*2)) > $(window).height();
    }
};

$(function() {
    var $sec = $('.filtro-productos-v1');

    if ($sec && $sec.length > 0) {
        $sec.each(function() {
             var filter = new _Filterv1($(this));
            filter.onReady();
        });

        var check_img = new Image(),
            check_img1 = new Image(),
            check_img2 = new Image(),
            check_img3 = new Image();

        check_img.src = '/fbin/css/img/default/input-check.png';
        check_img1.src = '/fbin/css/img/default/input-check-hover.png';
        check_img2.src = '/fbin/css/img/default/input-check-checked.png';
        check_img3.src = '/fbin/css/img/default/input-check-hover-checked.png';
    }
});

/*
==============================
Filter -> Filtro productos v2
==============================
*/

// force the plugin that aligns to do it's job
function pokeAlignerv2() {
    $(window).trigger('resize');
}

var _Filterv2 = function($sec) {
    var $filters = $sec.find('.filters'),
        $results = $sec.find('.filter-result-v2'),
        fTop = 85,
        fOldTop = 0,
        allResults = [],
        timer_resize,
        paginaActual = 0;

    this.onReady = function() {
        $results.each(function() {
            allResults.push($(this));
        })
        
        paginaActual = 0;
        for (var i = 0; i < 50 && i < allResults.length; i++) {
            allResults[i].fadeIn().promise().done(pokeAlignerv2);
        }
        if (allResults.length > 49) {
            paginationFiltersv2(allResults.length, allResults);
        }
        else {
            $('.total-results').text(allResults.length);
        }
        if (window.innerWidth > media.desktop && !isMobile.any()) {
            fTop = $filters.offset().top - $sec.offset().top;
            var minHeight = $(".filters.big").height();
            minHeight = minHeight + 250;
            $(".filter-results-v2").css("min-height", minHeight+"px");
            fixedDesktopFiltersv2();
            checkShrinkFiltersv2();
        }
        else if (window.innerWidth <= media.mobile) {
            $filters.css('height', $filters.find('.filters-top').outerHeight() + 4);
            $filters.find('label').on('click touchend', function(e) { e.stopPropagation(); });
            $filters.find('.filters-top, .apply-filters').on('click', fixedMobileFiltersv2);
        }

        $filters.find('.checkbox').on('change', checkboxClickedv2);

        $(window).on('scroll', function() {
            if (window.innerWidth > media.desktop && !isMobile.any()) {
                fixedDesktopFiltersv2();
            }
        }).on('resize', function() {
            if (window.innerWidth > media.mobile && window.innerWidth <= media.tablet) {
                $filters.attr('style', '');
            }
            else if (window.innerWidth > media.desktop && !isMobile.any()) {
                fixedDesktopFiltersv2();
            }
            $filters.css('opacity', 1);
        });
        $('.total-results').text($sec.find('.filter-result-v2').length);

        var cur_results = $sec.find('.filter-result-v2:visible').length;
        var text_cur_results = "1 - " + cur_results;

        if (cur_results > 0) {
            $sec.find('.filter-results-v2 p.title.title-xs').show();
            $sec.find('.filter-results-v2 p.title.title-xs.txt-rojo').hide();
            $('.current-results').text(text_cur_results);
        }
        else {
            $sec.find('.filter-results-v2 p.title.title-xs').hide();
            $sec.find('.filter-results-v2 p.title.title-xs.txt-rojo').show();
            $('.current-results').text(text_cur_results);
            if ($("#paginationFiltersContainer")) {
                $("#paginationFiltersContainer").remove();
            }
        }

        $filters.css('opacity', 1);
    };

    function checkboxClickedv2() {
        var $fMenus = $filters.find('.filter-menu-v2'),
            filters = [];

        $fMenus.each(function() {
            var dfilters = $(this).find('.checkbox:checked'),
                fIndex = filters.length;

            if (dfilters.length > 0) {
                dfilters.prop('disabled', true);
                filters[fIndex] = filters[fIndex] || [];
                dfilters.each(function() {
                    filters[fIndex].push($(this).data('filter'));
                });
            }
        });

        $(this).parent().toggleClass('on');

         if (window.innerWidth <= media.mobile || window.innerWidth > media.desktop) {
            $('html, body').animate({
                scrollTop: $sec.offset().top
            }, 300);
        }

        setTimeout(function() {
            $results.fadeOut(400).promise().done(function() {
                if (filters.length > 0) {
                    paginaActual = 0;
                    filterResultsv2(filters);
                }
                else{
                    paginaActual = 0;
                    for (var i = 0; i < 50 && i < allResults.length; i++) {
                        allResults[i].fadeIn().promise().done(pokeAlignerv2);
                    }
                    if (allResults.length > 49) {
                        paginationFiltersv2(allResults.length, allResults);
                    }
                    else {
                        $('.total-results').text(allResults.length);
                    }
                    // $results.fadeIn().promise().done(pokeAlignerv2);
                }

                var cur_results = $sec.find('.filter-result-v2:visible').length;
                var text_cur_results = "1 - " + cur_results;

                if (cur_results > 0) {
                    $sec.find('.filter-results-v2 p.title.title-xs').show();
                    $sec.find('.filter-results-v2 p.title.title-xs.txt-rojo').hide();
                    $('.current-results').text(text_cur_results);
                }
                else {
                    $sec.find('.filter-results-v2 p.title.title-xs').hide();
                    $sec.find('.filter-results-v2 p.title.title-xs.txt-rojo').show();
                    $('.current-results').text(text_cur_results);
                    if ($("#paginationFiltersContainer")) {
                        $("#paginationFiltersContainer").remove();
                    }
                }
                $fMenus.find('.checkbox').prop('disabled', false);
            });

            // console.log('foo');
        }, 300);
    }

    function filterResultsv2(filters) {
        var filtered = [];

        $results.each(function() {
            var toFiltered = false,
                thisFilters = $(this).data('filters');

            if (thisFilters && thisFilters.length > 0) {
                for (var j = 0; j < filters.length; j++) {
                    for (var i = 0; i < thisFilters.length; i++) {
                        if (filters[j].indexOf(thisFilters[i]) > -1) {
                            toFiltered = true;
                            break;
                        }
                        else {
                            toFiltered = false;
                        }
                    }
                    if (!toFiltered) break;
                }
            }

            if (toFiltered) {
                $(this).data("filteredDATA", true);
                filtered.push($(this));
            }
            else {
                $(this).data("filteredDATA", false);
            }
        });

        if (filtered.length > 50){
            for (var i = 0; i < 50; i++) {
                 filtered[i].fadeIn().promise().done(pokeAlignerv2);
            }
            paginationFiltersv2(filtered.length, filtered);
            // for (var i = 0; i < 50; i++) {
            //     filtered[i].fadeIn().promise().done(pokeAlignerv2);
            // }
            // if (filtered.length > 49){
            //     paginationFiltersv2(filtered.length, filtered);
            // }
            // else {
            //     $('.total-results').text(filtered.length);
            // }
        }
        else {
            $("#paginationFiltersContainer").remove();
            for (var i = 0; i < 50 && i < filtered.length; i++) {
                filtered[i].fadeIn().promise().done(pokeAlignerv2);
            }
            $('.total-results').text(filtered.length);
        }
    }

    function paginationFiltersv2(totalElem, elems) {
        if ($("#paginationFiltersContainer")) {
            $("#paginationFiltersContainer").remove();
        }
        var paginas = 5;
        var paginacionTotal = Math.ceil(totalElem/50);
        $('.total-results').text(totalElem);
        $(".filter-results-v2").append('<div id="paginationFiltersContainer" class="g-sm-12 clearBoth"> <div class="filter-v2-pagination"><div class="paginationText-v2"><p>Página <strong class="pagActual">1</strong> de <strong>'+paginacionTotal+'</strong></p></div><ul class="paginationList-v2"><li class="prevArrow-v2 disabled-v2" data-page="prev">Anterior</li><li class="nextArrow-v2" data-page="next">Siguiente</li></ul></div></div>');
        if (paginacionTotal < 5) {
            paginas = paginacionTotal;
        }
        for (var i = 0; i < paginas ; i++) {
            paginaActual = i+1;
            if (i == 0){
                $("#paginationFiltersContainer").find(".nextArrow-v2").before("<li class='active-v2 numberPag' data-page='"+paginaActual+"'>"+ paginaActual +"</li>")
            }
            else {
                $("#paginationFiltersContainer").find(".nextArrow-v2").before("<li class='numberPag' data-page='"+paginaActual+"'>"+ paginaActual +"</li>")
            }
        }
        paginacionClicked(paginacionTotal, elems);
    }

    function paginacionClicked(pagTotal, elems) {
        $("#paginationFiltersContainer li").bind("click", function(e){
            e.preventDefault();
            $("html").animate({scrollTop: 0}, 1000);
            if ($(window).width() > 480){
                $(".filters.big").css("position", "static");
            }
            var pagActiva = parseInt($("#paginationFiltersContainer li.active-v2").attr("data-page"));

            switch($(this).data("page")) {
                case "prev":
                    if(pagActiva > 1){
                        var paginaIrA = pagActiva - 1;
                        changePagina(paginaIrA, pagTotal, elems);
                    }
                    break;
                case "next":
                    if(pagTotal > pagActiva ){
                        var paginaIrA = pagActiva + 1;
                        changePagina(paginaIrA, pagTotal, elems);
                    }
                    break;
                default:
                    if (!$(this).hasClass("active-v2")){
                        changePagina(parseInt($(this).attr("data-page")), pagTotal, elems);
                    }
                    break;
            }
        })
    }

    function changePagina(pagToGo, totalPag, elems){
        $("#paginationFiltersContainer li:nth-child(2)").attr("data-page",pagToGo);
        $("#paginationFiltersContainer li:nth-child(2)").text(pagToGo);
        $("#paginationFiltersContainer .pagActual").text(pagToGo);
        if (pagToGo == totalPag) {
            $("#paginationFiltersContainer li").hide();
            $("#paginationFiltersContainer li:nth-child(2)").show();
            $("#paginationFiltersContainer li.nextArrow-v2").show();
            $("#paginationFiltersContainer li.prevArrow-v2").show();
        }
        else {
            $("#paginationFiltersContainer :nth-child(3)").hide();
            $("#paginationFiltersContainer :nth-child(4)").hide();
            $("#paginationFiltersContainer :nth-child(5)").hide();
            $("#paginationFiltersContainer :nth-child(6)").hide();
            for (var i = 3; i < 7; i++) {
                var pagIndex = pagToGo + i - 2;
                $("#paginationFiltersContainer li:nth-child("+i+")").attr("data-page",pagIndex);
                $("#paginationFiltersContainer li:nth-child("+i+")").text(pagIndex);
                $("#paginationFiltersContainer li:nth-child("+i+")").show();
                if (pagIndex == totalPag) {
                    break;
                }
            }
        }

        if (pagToGo == 1){
            var resultForPag = 0;
        }
        else {
            var resultForPag = (pagToGo-1)*50;
        }
        $results.hide();
        var resultFinal = 0;
        for (var i = resultForPag; i < resultForPag+50 && i <= elems.length-1; i++) {

            elems[i].fadeIn().promise().done(pokeAlignerv2);
            resultFinal = i;
        }
        $('.current-results').text((resultForPag+1)+" - "+(resultFinal+1));
        if (pagToGo > 1 && pagToGo < totalPag){
            $("#paginationFiltersContainer li.prevArrow-v2").removeClass("disabled-v2");
            $("#paginationFiltersContainer li.nextArrow-v2").removeClass("disabled-v2");
        }
        else if (pagToGo == totalPag) {
            $("#paginationFiltersContainer li.prevArrow-v2").removeClass("disabled-v2");
            $("#paginationFiltersContainer li.nextArrow-v2").addClass("disabled-v2");
        }
        else {
            $("#paginationFiltersContainer li.prevArrow-v2").addClass("disabled-v2");
            $("#paginationFiltersContainer li.nextArrow-v2").removeClass("disabled-v2");
        }
        $("#paginationFiltersContainer li.active-v2").removeClass("active-v2");
        $("#paginationFiltersContainer ul").find("[data-page='" + pagToGo + "']").addClass("active-v2");
    }

    function fixedDesktopFiltersv2() {
        var fwidth = $filters.outerWidth(),
            sbottomPos = ($sec.offset().top + $sec.outerHeight() - fTop) - $(window).height(),
            isOverSec = $(document).scrollTop() <= $sec.offset().top,
            isBelowSec = isFilterHigherThanSecv2();

        if (isBelowSec) {
            if ($filters.hasClass('fixed')) {
                var rTop = $sec.height() - $filters.height() - fTop;
                // console.log(rTop);
                $filters.css({
                    'top': rTop,
                    'left': 0,
                    'position':'relative'
                    // 'top': (isOverSec) ? fTop + ($sec.offset().top - $(document).scrollTop()) : fTop - $(document).scrollTop()
                });
                $sec.find('.filter-results-v2').css('margin-left', 0);

                $filters.removeClass('fixed');

                setTimeout(function() {
                    if (!$filters.hasClass('fixed')) {
                        // $filters.css({
                        //     position: 'static'
                        // });
                        //
                    }
                }, 800);
            }
        }
        else if (isOverSec) {
            if ($filters.hasClass('fixed')) {
                $filters.css({
                    position: 'static',
                    top: fTop
                });
                $sec.find('.filter-results-v2').css('margin-left', 0);
                $filters.removeClass('fixed');
            }
        }
        else if ($sec.offset().top <= $(document).scrollTop()) {
            if (!$filters.hasClass('fixed')) {
                $filters.css({
                    'top': (isOverSec) ? fTop + ($sec.offset().top - $(document).scrollTop()) : fTop - $(document).scrollTop()
                });
                $filters.css({
                    width: fwidth,
                    left: $filters.offset().left,
                    position: 'fixed',
                    top: fTop
                });
                $sec.find('.filter-results-v2').css('margin-left', fwidth);
                $filters.addClass('fixed');
            }
        }
    }

    function fixedMobileFiltersv2(e) {
        e.preventDefault();

        if (!$filters.hasClass('opened')) {
            $filters.css("height", $filters.find('.filters-top').outerHeight());
            $filters.css({
                height: $(window).height(),
                bottom: '0'
            });
            setTimeout(function() {
                $filters.addClass('opened').css({'overflow-y': 'scroll', 'overflow-x': 'hidden'});
                $filters.find('.filters-top .title-xs').slideDown();
                $('body').css('overflow-y', 'hidden');
                setTimeout(function() {
                    $filters.css('padding-top', $filters.find('.filters-top').outerHeight() + 4).find('.filter-menu-v2').fadeIn().promise().done(pokeAlignerv2);
                    onGlobalResize();
                }, 400);
            }, 800);
        }
        else {
            $filters.css({
                'overflow-y': 'visible',
                'overflow-x': 'visible'
            }).find('.filter-menu-v2').fadeOut(400);
            $filters.find('.filters-top .title-xs').slideUp(400);
            $('body').css('overflow-y', 'visible');

            setTimeout(function() {
                $filters.css({
                    bottom: '-3px',
                    height: $filters.find('.filters-top').outerHeight() + 4,
                    'padding-top': 0
                }).removeClass('opened');
            }, 400);
        }
    }

    function checkShrinkFiltersv2() {
        var isOverSec = $(document).scrollTop() <= $sec.offset().top,
            $flastMenu = $filters.find('.filter-menu-v2:not(.collapsed)').last();

        if ($filters.find('.filter-menu-v2:not(.collapsed)').length > 3 && isFilterHigherThanWindowv2()) {
            $flastMenu.addClass('collapsed');

            if (!$filters.find('.filters-layer').hasClass('big') && $filters.find('.filters-layer').height() + $flastMenu.height() < $filters.height()) {
                $filters.find('.filters-layer').css('width', $filters.width()).append($flastMenu);
            }
            else {
                $filters.addClass('big').find('.filters-layer').addClass('big').css('width', $filters.width()*2).append($flastMenu);
            }
            checkShrinkFiltersv2();
        }
    }

    function isFilterHigherThanSecv2() {
        return ($(document).scrollTop() - ($(window).height() - $filters.height() - fTop)) >= ($sec.offset().top + $sec.outerHeight() - fTop) - $(window).height();
    }

    function isFilterHigherThanWindowv2() {
        return ($sec.find('.filters').height() + (fTop*2)) > $(window).height();
    }
};

$(function() {
    var $sec = $('.filtro-productos-v2');

    if ($sec && $sec.length > 0) {
        $sec.each(function() {
             var filter = new _Filterv2($(this));
            filter.onReady();
        });

        var check_img = new Image(),
            check_img1 = new Image(),
            check_img2 = new Image(),
            check_img3 = new Image();

        check_img.src = '/fbin/css/img/default/input-check.png';
        check_img1.src = '/fbin/css/img/default/input-check-hover.png';
        check_img2.src = '/fbin/css/img/default/input-check-checked.png';
        check_img3.src = '/fbin/css/img/default/input-check-hover-checked.png';
    }
});


/*
==============================
Filter -> Filtro productos v3
==============================
*/

// force the plugin that aligns to do it's job
function pokeAlignerv3() {
    $(window).trigger('resize');
}

var _Filterv3 = function($sec) {
    var $filters = $sec.find('.filters'),
        $results = $sec.find('.filter-result-v3'),
        fTop = 85,
        fOldTop = 0,
        timer_resize;

    this.onReady = function() {

        $filters.find('.checkbox').on('change', checkboxClickedv3);

        $('.total-results').text($sec.find('.filter-result-v3').length);

        var cur_results = $sec.find('.filter-result-v3:visible').length;

        if (cur_results > 0) {
            $sec.find('.filter-results-v3 p.title.title-xs').show();
            $sec.find('.filter-results-v3 p.title.title-xs.txt-rojo').hide();
            $('.current-results').text(cur_results);
        }
        else {
            $sec.find('.filter-results-v3 p.title.title-xs').hide();
            $sec.find('.filter-results-v3 p.title.title-xs.txt-rojo').show();
        }
        $filters.css('opacity', 1);

        $(".filters-quit button").click(function(){
            $(".filter-menu-v3").find('input').each(function(){
                $(this).checkbox("uncheck");
            })
            checkboxClickedv3();
            $(".filters-quit button").prop('disabled', true);
        })
    };

    function checkboxClickedv3() {
        var $fMenus = $filters.find('.filter-menu-v3'),
            filters = [];

        $fMenus.each(function() {
            var dfilters = $(this).find('.checkbox:checked'),
                fIndex = filters.length;

            if (dfilters.length > 0) {
                dfilters.prop('disabled', true);
                filters[fIndex] = filters[fIndex] || [];
                dfilters.each(function() {
                    filters[fIndex].push($(this).data('filter'));
                });
            }
        });

        $(this).parent().toggleClass('on');

         if (window.innerWidth <= media.mobile || window.innerWidth > media.desktop) {
            $('html, body').animate({
                scrollTop: $sec.offset().top
            }, 300);
        }

        setTimeout(function() {
            $results.fadeOut(400).promise().done(function() {
                if (filters.length > 0)
                    filterResultsv3(filters);
                else
                    $results.fadeIn().promise().done(pokeAlignerv3);

                var cur_results = $sec.find('.filter-result-v3:visible').length;

                if (cur_results > 0) {
                    $sec.find('.filter-results-v3 p.title.title-xs').show();
                    $sec.find('.filter-results-v3 p.title.title-xs.txt-rojo').hide();
                    $('.current-results').text(cur_results);
                }
                else {
                    $sec.find('.filter-results-v3 p.title.title-xs').hide();
                    $sec.find('.filter-results-v3 p.title.title-xs.txt-rojo').show();
                }
                $fMenus.find('.checkbox').prop('disabled', false);
            });

            // console.log('foo');
        }, 300);
    }

    function filterResultsv3(filters) {
        var filtered = [];

        $results.each(function() {
            var toFiltered = false,
                thisFilters = $(this).data('filters');

            if (thisFilters && thisFilters.length > 0) {
                for (var j = 0; j < filters.length; j++) {
                    for (var i = 0; i < thisFilters.length; i++) {
                        if (filters[j].indexOf(thisFilters[i]) > -1) {
                            toFiltered = true;
                            break;
                        }
                        else {
                            toFiltered = false;
                        }
                    }
                    if (!toFiltered) break;
                }
            }

            if (toFiltered) {
                filtered.push($(this));
            }
        });

        for (var i = 0; i < filtered.length; i++) {
            filtered[i].fadeIn().promise().done(pokeAlignerv3);
        }
    }

    function checkShrinkFiltersv3() {
        var isOverSec = $(document).scrollTop() <= $sec.offset().top,
            $flastMenu = $filters.find('.filter-menu-v3:not(.collapsed)').last();

        if ($filters.find('.filter-menu-v3:not(.collapsed)').length > 3 && isFilterHigherThanWindowv3()) {
            $flastMenu.addClass('collapsed');

            if (!$filters.find('.filters-layer').hasClass('big') && $filters.find('.filters-layer').height() + $flastMenu.height() < $filters.height()) {
                $filters.find('.filters-layer').css('width', $filters.width()).append($flastMenu);
            }
            else {
                $filters.addClass('big').find('.filters-layer').addClass('big').css('width', $filters.width()*2).append($flastMenu);
            }
            checkShrinkFiltersv3();
        }
    }

    function isFilterHigherThanSecv3() {
        return ($(document).scrollTop() - ($(window).height() - $filters.height() - fTop)) >= ($sec.offset().top + $sec.outerHeight() - fTop) - $(window).height();
    }

    function isFilterHigherThanWindowv3() {
        return ($sec.find('.filters').height() + (fTop*2)) > $(window).height();
    }
};

$(function() {
    var $sec = $('.filtro-productos-v3');

    if ($sec && $sec.length > 0) {
        $sec.each(function() {
             var filter = new _Filterv3($(this));
            filter.onReady();
        });
    }

    $(".filtro-productos-v3").find(".filters-top").click(function(){
        if ($(this).hasClass("activeFilters")){
            if ($(window).width() >= 480){
                $(".filter-check-v3").css("height", "63px");
            } else {
                $(".filter-check-v3").css("height", "86px");
            }
            $(this).removeClass("activeFilters");
            $(this).find("i").removeClass("icon-uniE072");
            $(this).find("i").addClass("icon-uniE073");
        }
        else{
            $(".filter-check-v3").css("height", "100%");
            $(this).addClass("activeFilters");
            $(this).find("i").removeClass("icon-uniE073");
            $(this).find("i").addClass("icon-uniE072");
        }
    })

    $('.first-part').each( function(){
        if($(this).offset().top < $(window).height()){
            $(this).find(".imgLittleShow").animate({'opacity':'1'},1000);
            $(this).find(".imgBigShow").animate({'opacity':'1'},1500);
        }
    });

    $('.filter-menu-v3 li input').click(function(){
        var disabledFilters = true;
        $(this).each(function(){
            if ($(this).is(":checked")){
                disabledFilters = false;
            }
        })
        if (disabledFilters){
            $(".filters-quit button").prop('disabled', true);
        }else{
            $(".filters-quit button").prop('disabled', false);
        }
    })


    
    /* Every time the window is scrolled ... */
    $(window).scroll( function(){
        var bottom_of_window = $(window).scrollTop() + $(window).height();
        /* Check the location of each desired element */
        $('.first-part').each( function(){
            
            var bottom_of_object = $(this).offset().top + 150;
            /* If the object is completely visible in the window, fade it it */
            if( bottom_of_window > bottom_of_object ){
                $(this).find(".imgLittleShow").animate({'opacity':'1'},1000);
                $(this).find(".imgBigShow").animate({'opacity':'1'},1500);
            }
            
        }); 
    });

});